import * as Yup from 'yup'
import { z, z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const OrdersDetailsWestfieldCorpDefaultSchemas = DefaultSchemas

const OrdersDetailsWestfieldCorpDetailsCardsDataSchemas = zod.object({
  traderId: zod.number(),
  traderTransIdent: zod.string(),
})

const OrdersDetailsWestfieldCorpDetailsDataSchemas = zod.object({
  detailId: zod.string(),
  value: zod.number(),
  quantity: zod.number(),
  productName: zod.number(),
  cards: zod.array(OrdersDetailsWestfieldCorpDetailsCardsDataSchemas),
})

export const OrdersCardsSchemas = zod.object({
  cardId: zod.number().nullable(),
  detailId: zod.number().nullable(),
  traderId: zod.number().nullable(),
  cardNumber: zod.string().nullable(),
})

export const OrdersDetailsSchemas = zod.object({
  cardNumberStart: zod.number().nullable(),
  cardNumberEnd: zod.number().nullable(),
  detailId: zod.number().nullable(),
  detailType: zod.number().nullable(),
  orderId: zod.number(),
  productId: zod.number(),
  productName: zod.string(),
  quantity: zod.number(),
  value: zod.number(),
})

export const OrdersDetailsWestfieldCorpDataSchemas = zod.object({
  cardDetails: OrdersCardsSchemas.array(),
  orderDetails: OrdersDetailsSchemas.array(),
})

export const OrdersDetailsWestfieldCorpAPISchemas =
  OrdersDetailsWestfieldCorpDefaultSchemas.merge(
    zod.object({
      data: OrdersDetailsWestfieldCorpDataSchemas.nullable(),
    })
  )

export const OrdersDetailsWestfieldCorpFetchParamsSchemas = zod.object({
  orderId: zod.number().optional().nullable(),
})

export const OrdersDetailsWestfieldCorpUpdateParamsSchemas = zod.object({
  traderId: zod.number(),
  noteId: zod.number(),
  noteTypeId: zod.string(),
  priorityLevel: zod.string(),
  noteDescription: zod.string(),
  creationDate: zod.string(),
  sourceName: zod.string(),
})
